/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Tooltip,
} from "@chakra-ui/react";
import { CheckIcon, CloseIcon, QuestionIcon } from "@chakra-ui/icons";

interface B4FEmailProps {
  label?: string;
  isRequired?: boolean;
  value?: string;
  placeholder?: string;
  id?: string;
  onBlur?: any;
  onChange: (e: any) => void;
  isDisabled: boolean;
  isInvalid?: boolean;
  visible: boolean;
  tooltip?: string;
  defaultValue?: any;
}

export const B4FEmail: React.FC<B4FEmailProps> = (props) => {
  const [value, setValue] = useState(props.value);
  const [isValid, setIsValid] = useState(false);

  function handleChange(e: any) {
    setValue(e.target.value);
  }

  useEffect(() => {
    validateInput(value);
  }, [value]);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  function validateInput(input: string | undefined) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(input).toLowerCase())) {
      setIsValid(true);
      return true;
    } else {
      setIsValid(false);
      return false;
    }
  }

  function handleBlur(e: { target: { value: any } }) {
    if (isValid) {
      props.onBlur({
        id: props.id,
        type: "email",
        value: e.target.value,
      });
    }
  }

  let rightElement;

  if (!isValid) {
    rightElement = (
      <InputRightElement>{<CloseIcon color="red.500" />}</InputRightElement>
    );
  } else {
    rightElement = (
      <InputRightElement>{<CheckIcon color="green.500" />}</InputRightElement>
    );
  }

  if (props.visible) {
    return (
      <FormControl key={props.label} mb={2} isDisabled={props.isDisabled}>
        <Flex>
          <FormLabel>{props.label}</FormLabel>
          {props.tooltip && props.tooltip !== "" ? (
            <Tooltip
              label={props.tooltip}
              fontSize="md"
              bg="brand.white"
              color="brand.text"
            >
              {props.isDisabled ? (
                <QuestionIcon color="brand.grey" />
              ) : (
                <QuestionIcon color="brand.bf2" />
              )}
            </Tooltip>
          ) : null}
        </Flex>
        <InputGroup>
          <Input
            color="#636E95"
            isRequired={props.isRequired}
            isDisabled={props.isDisabled}
            isInvalid={props.isInvalid}
            defaultValue={props.defaultValue}
            id={props.id}
            type="text"
            bg="brand.inputBackground"
            placeholder={props.placeholder}
            focusBorderColor="brand.bf3"
            value={value}
            onChange={props.onChange}
            onBlur={handleBlur}
          />
          {rightElement}
        </InputGroup>
      </FormControl>
    );
  } else {
    return null;
  }
};
